import {
  JOBCASE_SSO_VIEW_RENDERED,
  JOBCASE_CREATE_ACC_NATIVE_AUTH_CLICKED,
  JOBCASE_CREATE_ACC_NATIVE_AUTH_ERROR,
  JOBCASE_LOGIN_NATIVE_AUTH_CLICK,
  JOBCASE_LOGIN_NATIVE_AUTH_ERROR,
  JOBCASE_SSO_LOGIN,
} from '../constants/reportableEventConstants';
import reporter from '../reporter';

const AUTH_ERROR_REASON = {
  PASSWORD: 'PASSWORD',
  EMAIL: 'EMAIL',
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
};

const SSO_LOGIN_TYPE = {
  SOCIAL: 'social',
  SOCIAL_MATCH_BY_PROFILE_KEY: 'social-match-by-profile-key',
  SOCIAL_MATCH_BY_EMAIL: 'social-match-by-email',
  SOCIAL_VERIFY_EMAIL: 'social-verify-email',
  SOCIAL_CAPTURE_EMAIL: 'social-capture-email',
  CLAIM: 'claim',
  STANDARD: 'standard',
};

const SSO_PAGE = {
  SIGNUP: 'SIGNUP',
  LOGIN: 'LOGIN',
  RECOVER_PASSWORD: 'RECOVER_PASSWORD',
};

/**
 * Reports SSO View Rendered
 *
 * @param {SSO_PAGE} page
 */
const reportJobcaseSsoViewRendered = async (page) => {
  const eventData = {
    occurred_at: Date.now(),
    path: page,
    status: '201',
  };
  reporter.report(JOBCASE_SSO_VIEW_RENDERED, eventData);
};

/**
 * Reports when the “Join Jobcase” button is hit from the signup page, specifically only using email and password, not oauth/social
 */
const reportJobcaseCreateAccNativeAuthClick = async () => {
  reporter.report(JOBCASE_CREATE_ACC_NATIVE_AUTH_CLICKED, {});
};

/**
 * Reports when validation fails when user attempts to submit the signup form without all required fields
 *
 * @param {AUTH_ERROR_REASON} field
 */
const reportJobcaseCreateAccNativeAuthError = async (field, weak_password_validation = false) => {
  const eventData = {
    field,
    weak_password_validation,
  };
  reporter.report(JOBCASE_CREATE_ACC_NATIVE_AUTH_ERROR, eventData);
};

/**
 * Reports when “Log in” is hit from the login page, specifically only using email and password, not oauth/social
 */
const reportJobcaseLoginNativeAuthClick = async () => {
  reporter.report(JOBCASE_LOGIN_NATIVE_AUTH_CLICK, {});
};

/**
 * Reports when user attempts to submit the login form without all required fields
 *
 * @param {AUTH_ERROR_REASON} field
 */
const reportJobcaseLoginNativeAuthError = async (field) => {
  const eventData = {
    field,
  };
  reporter.report(JOBCASE_LOGIN_NATIVE_AUTH_ERROR, eventData);
};

/**
 * Reports when user has successfully logged in
 *
 * @param {SSO_LOGIN_TYPE} type
 */
const reportJobcaseSsoLogin = async (type) => {
  const eventData = {
    type,
  };
  reporter.report(JOBCASE_SSO_LOGIN, eventData);
};

export {
  reportJobcaseCreateAccNativeAuthClick,
  reportJobcaseCreateAccNativeAuthError,
  reportJobcaseLoginNativeAuthClick,
  reportJobcaseLoginNativeAuthError,
  reportJobcaseSsoViewRendered,
  reportJobcaseSsoLogin,
  AUTH_ERROR_REASON,
  SSO_PAGE,
  SSO_LOGIN_TYPE,
};

export default {
  reportJobcaseCreateAccNativeAuthClick,
  reportJobcaseCreateAccNativeAuthError,
  reportJobcaseLoginNativeAuthClick,
  reportJobcaseLoginNativeAuthError,
  reportJobcaseSsoViewRendered,
  reportJobcaseSsoLogin,
  AUTH_ERROR_REASON,
  SSO_PAGE,
  SSO_LOGIN_TYPE,
};
